import i18n from "src/app/shared/localization/i18n";
// toastr messages
export const CONTACT_CREATING_ERROR_MESSAGE: string = i18n.t('contact.contactCreatingErrorMessage');
export const REQUESTED_NUMBER_OF_CONTACTS_FIRST_TIME: number = 20;
export const REQUESTED_NUMBER_OF_CONTACTS: number = 10;
export const TRIGGER_SCROLL_HEIGHT: number = 10;
export const SEARCHING_INPUT_PLACEHOLDER: string = i18n.t('contact.searchingInputPlaceholder');